<template>

    <v-container fluid>

        <v-col :alvqa="alvqa + '-title'">
            <v-row class="pl-4 pb-4 headline">
                {{ item.contractName }}
            </v-row>
        </v-col>

        <v-row class="pl-4 pr-4">
            <!-- FIRST CARD  -->
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <!-- TYPE -->
                        <span v-if="item.contractType !== null && item.contractType !== '' && item.contractType !== undefined">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-type'"
                            >{{ $t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_TYPE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-type'"
                            >{{ this.getContractType(item) }}</div>
                        </span>

                        <!-- Contracting party -->
                        <span v-if="item.licensor !== null && item.licensor !== undefined">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-licensor'"
                            >{{ $t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACTING_PARTY') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-licensor'"
                            >{{ $alvPlugin.showNameOfAzEntry(item.licensor) }}</div>
                        </span>

                        <!-- AlvId -->
                        <span v-if="item.alvId !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-alvid'"
                            >{{ $t('lang_CONTRACTS_LABEL_CAPTION_CONTRACT_ID') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-alvid'"
                            >{{ item.alvId }}</div>
                        </span>

                    </v-card-text>
                </v-card>
            </v-col>

            <!-- SECOND CARD  -->
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <!-- INITIAL BALANCE -->
                        <span v-if="item.initialBalance !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-initial-balance'"
                            >{{ $t('lang_CONTRACTS_LABEL_CAPTION_INITIAL_BALANCE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-initial-balance'"
                            >{{ item.initialBalance }}</div>
                        </span>

                        <!-- InitialBalance -->
                        <span v-if="item.initialBalancePeriod.period !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-initial-balance-period'"
                            >{{ $t('lang_CONTRACTS_LABEL_CAPTION_INITIAL_BALANCE_PERIOD') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-initial-balance-period'"
                            >{{ $alvPlugin.displayPeriod(item.initialBalancePeriod,false) }}</div>
                        </span>

                        <!-- CONTRACT DATE -->
                        <span v-if="item.contractDate !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-contract-date'"
                            >{{ $t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_DATE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-contract-date'"
                            >{{ $d(new Date(item.contractDate),'alvDateFormat') }}</div>
                        </span>

                    </v-card-text>
                </v-card>
            </v-col>

            <!-- THIRD CARD  -->
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <!-- RESERVE -->
                        <span v-if="item.reserve !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-reserve'"
                            >{{ $t('lang_LABEL_CONTRACTS_CAPTION_RESERVE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-reserve'"
                            >{{ $n(item.reserve, 'number') }}</div>
                        </span>

                        <!-- SETTLED AFTER -->
                        <span v-if="item.resolutionPeriod !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-resolution-period'"
                            >{{ $t('lang_LABEL_CONTRACTS_CAPTION_RESERVE_SETTLE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-resolution-period'"
                            >{{ getResolutionPeriod(item) }}</div>
                        </span>

                        <!-- BILLING CYCLE -->
                        <span v-if="item.billingCycle !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-billing-cycle'"
                            >{{ $t('lang_CONTRACTS_LABEL_CAPTION_STATEMENT_SCHEDULE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-billing-cycle'"
                            >{{ getBilingsCycle(item.billingCycle) }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="item.notes !== ''" class="pl-4 pr-4">
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                         <!-- NOTES -->
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-notes'"
                            >{{ $t('lang_GENERIC_CAPTION_NOTES') }}:</div>
                            <div
                                :alvqa="alvqa + '-notes'"
                            >{{ item.notes }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                         
                         <!-- VALID FROM -->
                        <span v-if="item.validFrom !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-valid-from'"
                            >{{ $t('lang_CONTRACTS_LABEL_CAPTION_VALID_FROM') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-valid-from'"
                            >{{  $d(new Date(item.validFrom),'alvDateFormat') }}</div>
                        </span>
                        <!-- VALID UNTIL -->
                        <span v-if="item.validUntil !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-valid-until'"
                            >{{ $t('lang_CONTRACTS_LABEL_CAPTION_VALID_UNTIL') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-valid-until'"
                            >{{ $d(new Date(item.validUntil),'alvDateFormat') }}</div>
                        </span>
                        <!-- REMINDER DATE -->
                        <span v-if="item.reminderDate !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-reminder-date'"
                            >{{ $t('lang_CONTRACTS_LABEL_CAPTION_REMINDER_DATE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-reminder-date'"
                            >{{ $d(new Date(item.reminderDate),'alvDateFormat') }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- TRACKS/VÖ PANEL -->
        <v-row class="pl-4 pr-4">
            <v-col>
                <v-expansion-panels multiple focusable tile flat><TracksReleasesReadOnlyPanel /></v-expansion-panels>
                <v-expansion-panels multiple focusable tile flat><LabelContractsSplitsReadOnlyPanel /></v-expansion-panels>
                <v-expansion-panels multiple focusable tile flat><LabelContractsGroupedContractsReadOnlyPanel /></v-expansion-panels>

            </v-col>

        </v-row>

    </v-container>
  
</template>

<script>
import TracksReleasesReadOnlyPanel from './_panels/1_tracks/TracksReleasesReadOnlyPanel.vue'
import LabelContractsSplitsReadOnlyPanel from './_panels/2_splits/LabelContractsSplitsReadOnlyPanel.vue'
import LabelContractsGroupedContractsReadOnlyPanel from './_panels/3_groupedContracts/LabelContractsGroupedContractsReadOnlyPanel.vue'

import {DropdownLabelContractsContractTypes,
        DropdownLabelContractsBillingCycles,
        DropdownLabelContractsResolutionPeriods
} from '@/assets/dropdowns/alvDropdowns.js'
export default {
    name: 'LabelContractsReadOnly',

    components:{
        TracksReleasesReadOnlyPanel,
        LabelContractsSplitsReadOnlyPanel,
        LabelContractsGroupedContractsReadOnlyPanel
    },

    props:{
        itemId: {
            type: Number
        }
    },

    data() {
        return {
            alvqa: 'label-contracts-list-row-' + this.itemId + '-read-only'
        }
    },
    methods:{
        getContractType(item){
            let types = DropdownLabelContractsContractTypes

            if(item.contractType === undefined || item.contractType === null){
                return 
            }else{
                return this.$t(types.find(element => {
                    return element.value === item.contractType
                }).text)
            }
        },
        getBilingsCycle(value){
            let types = DropdownLabelContractsBillingCycles

            if(value === undefined || value === null){
                return 
            }else{
                return this.$t(types.find(element => {
                    return element.value === value
                }).text)
            }
        },
        getResolutionPeriod(item){
            let match = DropdownLabelContractsResolutionPeriods.find(period => {
                return period.value === item.resolutionPeriod
            })

            if(match === undefined) return null
            else {
                return this.$t(match.text)
            }
        },
        // getContractingParty(item){
        //     if(item.licensor !== null || item.licensor !== undefined){
        //         return item.licensor.gemaName
        //     }
        // }
    },
    computed: {
        item() { 
            if(this.$store.getters.getExpandedLabelContracts.length !== 0){
                return this.$store.getters.getExpandedLabelContracts[0]
            }
        },

        resolutionPeriods() {
            return DropdownLabelContractsResolutionPeriods
        },
        billingCycles() {
            return DropdownLabelContractsBillingCycles
        },
    }

}
</script>

<style>

</style>